import { getRefundPassengerLabel, getRefundChildIds } from './refundPassengerUtils';
/**
 * Преобразует `RefundPassenger[]` в строки чекбоксов для шага Passengers.
 * Порядок строк: взрослый, затем его дети.
 */
export const buildRefundCheckboxPassengers = (passengers, childRefundWithoutAdultAllowed) => {
    var _a, _b, _c, _d;
    const checkboxPassengers = [];
    for (const adult of passengers) {
        if (adult.type !== 'ADT') {
            continue;
        }
        if ((_a = adult.children) === null || _a === void 0 ? void 0 : _a.length) {
            checkboxPassengers.push({
                ids: [adult.id, ...getRefundChildIds(adult)],
                label: getRefundPassengerLabel(adult),
                isSelected: adult.isSelected,
                isDisabled: (_b = adult.isDisabled) !== null && _b !== void 0 ? _b : false
            });
            if (childRefundWithoutAdultAllowed) {
                for (const child of adult.children) {
                    if (child.type !== 'CLD') {
                        continue;
                    }
                    checkboxPassengers.push({
                        ids: [child.id],
                        label: getRefundPassengerLabel(child),
                        isSelected: child.isSelected,
                        isDisabled: (_c = child.isDisabled) !== null && _c !== void 0 ? _c : false
                    });
                }
            }
            continue;
        }
        checkboxPassengers.push({
            ids: [adult.id],
            label: getRefundPassengerLabel(adult),
            isSelected: adult.isSelected,
            isDisabled: (_d = adult.isDisabled) !== null && _d !== void 0 ? _d : false
        });
    }
    return checkboxPassengers;
};
